import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';
import pxToRem from 'styles/pxToRem';

import { accountSendCode } from 'redux/modules/account';

import LoginConfirmForm from './LoginConfirmForm';

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    minHeight: 434,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: 556,
    },
  },
  form: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '25px 113px 0',
    },
  },
  footer: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '25px 113px 48px',
    },
  },
  button: {
    paddingTop: 15,
    paddingBottom: 15,
    width: '100%',
  },
  typography: {
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: 14,
    margin: `${pxToRem(24)} ${pxToRem(113)}`,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  typographyText: {
    fontSize: pxToRem(13),
    margin: `0 ${pxToRem(113)} ${pxToRem(16)}`,
  },
});

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      codeTransport: null,
      phone: null,
      expireIn: null,
      email: null,
    };

    this.onSendCode = this.onSendCode.bind(this);
    this.onSendCodeSuccess = this.onSendCodeSuccess.bind(this);
  }

  onSendCode(transport) {
    const { actions, initialValues } = this.props;
    actions.accountSendCode({
      values: {
        Email: initialValues.Email,
        Transport: transport,
      },
      resolve: (values) => this.onSendCodeSuccess({
        codeTransport: transport,
        phone: values.phone,
        expireIn: 15, //values.expire_in,
        email: values.email,
      }),
    });
  }

  onSendCodeSuccess( { codeTransport, phone, expireIn, email }) {
    this.setState({ codeTransport, phone, expireIn, email });
  }

  render() {
    const { form, submitting, onSubmitSuccess, actions, initialValues, classes } = this.props;
    const { codeTransport, phone, expireIn, email } = this.state;

    return (
      <Paper
        className={classes.root}
        square
        elevation={5}
      >
        <Typography
            className={classes.typography}
            color="secondary"
          >
            We need to confirm your login
        </Typography>
        {codeTransport ? (
          <Fragment>
            <Typography
              className={classes.typographyText}
              align="center"
            >
              Please, enter authentication code that we sent to {codeTransport === 'email' ? email : phone}. 
              You have {expireIn} minutes untill security code will expire.
            </Typography>
            <LoginConfirmForm
              className={classes.form}
              form={form}
              onSubmitSuccess={onSubmitSuccess}
              initialValues={initialValues}
              onCodeResend={() => this.onSendCode(codeTransport)}
            />
          </Fragment>
        ) : (
          <Typography
            className={classes.typographyText}
            align="center"
          >
            Two-Factor Authentication adds extra layer of security to your work in our application.
            Please, select how you wish to receive access code.
          </Typography>
        )}
        <div className={classes.footer}>
          {codeTransport ? (
            <Button
              className={classes.button}
              onClick={() => actions.submit(form)}
              variant="raised"
              color="primary"
              disabled={submitting}
            >
              Submit
            </Button>
          ) : (
             <Grid
              container
              spacing={24}
            >
              <Grid
                item
                xs={6}
              >
                <Button
                  className={classes.button}
                  onClick={() => this.onSendCode('email')}
                  variant="raised"
                  color="primary"
                >
                  Email
                </Button>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <Button
                  className={classes.button}
                  onClick={() => this.onSendCode('phone')}
                  variant="raised"
                  color="primary"
                >
                  SMS
                </Button>
              </Grid>
            </Grid>
          )}
        </div>
      </Paper>
    );
  }
};

Login.propTypes = {
  form: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
    accountSendCode: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

Login.defaultProps = {
  form: 'login-confirm',
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, accountSendCode }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(Login),
);



// WEBPACK FOOTER //
// ./src/components/account/LoginConfirm/LoginConfirm.js